import type { MessageSlot } from "@/lib/widget-config";

const plain = (s: string) =>
  s
    .replace(/<[^>]*>/g, " ")
    .replace(/\s+/g, " ")
    .trim();

/**
 * The BE inserts the slot text as the FIRST BOT message of a slot / manually started thread (flagged
 * `isThreadSeed` on the BE, but not exposed over SSE / history). The visitor already saw that text in the
 * bubble / thread, so it must be absorbed silently (no sound, notification, unread or peek). Detected by
 * a bot / ai sender whose text equals the text of a MESSAGE slot variant.
 */
export function isThreadSeedMessage(
  msg: { text?: string | null; senderKind?: string | null },
  slots: readonly MessageSlot[] | null | undefined,
): boolean {
  if (msg.senderKind !== "bot" && msg.senderKind !== "ai") return false;
  const text = plain(msg.text ?? "");
  if (!text || !slots) return false;
  return slots.some((s) => s.kind === "MESSAGE" && s.variants.some((v) => plain(v.text) === text));
}
